/**
 * CreatorConfigContext.jsx
 * frontend/src/contexts/CreatorConfigContext.jsx
 *
 * Fetch creator config 1 lần khi app load, share toàn bộ app.
 * Dùng để:
 *   1. Sidebar ẩn/hiện nav
 *   2. BlockedRoute chặn URL trực tiếp nếu trang bị ẩn
 *   3. useFeature("key") — ẩn/hiện từng tính năng nhỏ trong trang
 */

import React, { createContext, useContext, useEffect, useState } from "react";

const DEFAULT_CONFIG = {
  hidden_nav: [],
  hidden_features: [],
  hide_admin_settings: false,
  creator_watermark: "",
  creator_watermark_visible: false,
};

// Map: nav key → đường dẫn (path prefix)
export const NAV_KEY_TO_PATH = {
  dashboard:    "/dashboard",
  orders:       "/orders",
  products:     "/products",
  materials:    "/materials",
  production:   "/production",
  customers:    "/customers",
  customerCare: "/customer-care",
  insights:     "/insights",
  suppliers:    "/suppliers",
  debts:        "/debts",
  delivery:     "/delivery",
  users:        "/users",
  reports:      "/reports",
  finance:      "/finance",
  settings:     "/settings",
};

const CreatorConfigContext = createContext({ config: DEFAULT_CONFIG, loading: true });

export function CreatorConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${backendUrl}/api/creator/public-config`)
      .then((r) => r.json())
      .then((data) => setConfig({ ...DEFAULT_CONFIG, ...data }))
      .catch(() => {}) // lỗi mạng → giữ default (hiện tất cả)
      .finally(() => setLoading(false));
  }, []);

  return (
    <CreatorConfigContext.Provider value={{ config, loading }}>
      {children}
    </CreatorConfigContext.Provider>
  );
}

export function useCreatorConfig() {
  return useContext(CreatorConfigContext);
}

/**
 * useFeature(featureKey) → true = tính năng đang BẬT (hiện), false = bị ẩn
 *
 * Dùng trong bất kỳ trang nào:
 *   const canSeeRecipe    = useFeature("products.recipe");
 *   const canPrintOrders  = useFeature("orders.print");
 *   {canSeeRecipe && <Button>Công thức</Button>}
 */
export function useFeature(featureKey) {
  const { config } = useContext(CreatorConfigContext);
  return !(config.hidden_features || []).includes(featureKey);
}